<template>
  <div class="tree-node accordion" role="tablist">
    <b-card no-body class="mb-0">
      <b-card-header
        header-tag="header"
        class="node-header pl-1"
        :class="{'cursor-none': !hasParent || hasChildren || !canChat}"
        role="tab"
        v-b-toggle="`accordion-${node.id}`"
        @click="handleClick"
      >
        <div
          class="msg-wrapper"
          :class="{ 'no-child': !hasChildren }"
        >
          <b-card-text
            title-tag="h5"
            v-b-tooltip.hover.left
            :title="!hasParent || hasChildren ? '' : getNoteDescription(node)"
          >
            <feather-icon
              v-if="hasChildren"
              class="ChevronRightIcon"
              size="20"
              icon="ChevronRightIcon"
            />
            <feather-icon
              v-if="hasChildren"
              class="ChevronDownIcon d-none"
              size="20"
              icon="ChevronDownIcon"
            />
            <feather-icon
              v-if="!hasChildren"
              size="16"
              icon="FileTextIcon"
              class="FileTextIcon"
            />
            {{ getNodeTitle(node.title) }}
          </b-card-text>
          <!-- <b-card-sub-title :class="{'mb-1': isRoot}"
            v-if="!hasChildren"
          >
            {{ node.description }}
          </b-card-sub-title> -->
        </div>
        <!-- <div
          v-if="!hasChildren && canChat"
          role="button"
          class="text-primary px-1"
          @click="handleClick"
        >
          <feather-icon
            size="16"
            icon="SendIcon"
          />
        </div> -->
      </b-card-header>
        <b-collapse
        v-if="hasChildren"
        :id="`accordion-${node.id}`"
        visible
        :accordion="`accordion-${node.id}`"
        role="tabpanel"
      >
        <b-card-body class="py-0 pr-0">
          <tree-node
            v-for="item in node.children"
            :key="item.id"
            :node="item"
            :sendTextMessage="sendTextMessage"
            :active-channel="activeChannel"
          />
        </b-card-body>
      </b-collapse>
    
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BCardSubTitle,
  BLink,
  BModal,
  BButton,
  BButtonGroup,
  BAlert,
  BCardHeader,
  BCardBody,
  BCollapse,
} from "bootstrap-vue";
export default {
  name: 'TreeNode',
  props: {
    node: {
      type: Object,
      required: true
    },
    sendTextMessage: {
      type: Function,
      require: true
    },
    activeChannel: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BCardSubTitle,
    BLink,
    BModal,
    BButton,
    BButtonGroup,
    BAlert,
    BCardHeader,
    BCardBody,
    BCollapse,
  },
  data() {
    return {
      showChildren: true
    }
  },
  mounted() {
    // console.log(this.activeChannel)
  },
  computed: {
    nodeMargin() {
      return {
        'margin-left': `${this.spacing}px`
      }
    },
    hasChildren() {
      const { children } = this.node
      return children && children.length > 0
    },
    hasParent() {
      return !!this.node.parent;
    },
    isRoot() {
      return !this.node.parent
    },
    toggleChildrenIcon() {
      return this.showChildren ? 'fas fa-angle-down' : 'fas fa-angle-right'
    },
    canChat() {
      return this.activeChannel.state == 1;
    },
    locale() {
      return this.$i18n.locale.split('-')[0]
    }
  },
  methods: {
    getNoteDescription(node) {
      if (typeof node?.description === 'object') {
        return node?.description?.[this.locale] || node?.description?.en || node?.description?.zh || node?.description?.km || node?.description?.vi || node?.description
      }
      return node?.description
    },
    getNodeTitle(title) {
      if (typeof title === 'object') {
        return title[this.locale] || title.en || title.zh || title.km || title.vi || title
      }
      return title
    },
    toggleChildren() {
      this.showChildren = !this.showChildren
    },
    handleClick() {
      if (
        this.hasChildren
        || !this.canChat
        || !this.hasParent
      ) {
        return;
      }
      this.sendTextMessage(this.node.description)
    }
  }
}
</script>

<style lang="scss">
  .tree-node.accordion {
    .card {
      box-shadow: unset;
      border-radius: 0;
      .node-header {
        &:hover {
          background-color: #eee;
        }
        &.cursor-none {
          cursor: not-allowed;
        }
        cursor: default;
        padding-top: 2px;
        padding-bottom: 2px;
        padding-right: 0;
      }
    }
    .msg-wrapper {
      padding: 2px 8px;
      width: 100%;
      border-radius: 4px;
      &.no-child {
        max-width: calc(100% - 45px);
      }
      .FileTextIcon {
        margin-bottom: 3px;
        margin-right: 3px;
      }
    }
    h5 {
      font-size: 1rem;
      font-weight: 900;
      margin-bottom: 3px;
    }
    .ChevronRightIcon, .ChevronDownIcon {
      margin-bottom: 0.3rem;
      transition: visibility 0.3s linear;
    }
    .not-collapsed {
      .ChevronRightIcon {
        display: none;
      }
      .ChevronDownIcon {
        display: inline-block !important;
      }
    }
  }
</style>